function registerTealiumTracker(tealiumAccount, callback = null) {
    // localStorage.setItem('tealium_visitor_id', tealiumVisitorId);

    const script = window.document.createElement('script');
    script.src = `https://tags.tiqcdn.com/utag/${tealiumAccount}/tradepending/prod/utag.js`;
    script.type = 'text/javascript';
    script.async = true;

    script.onload = () => {
        if (callback) {
            callback();
        }
    };

    script.onerror = () => {
        console.error("Failed to load Tealium script.");
    };
 
    const baseScriptUrl = `https://tags.tiqcdn.com/utag/${tealiumAccount}/tradepending/prod/utag.js`;
    const existingScript = Array.from(window.document.scripts).find(script => script.src.startsWith(baseScriptUrl));
    if (!existingScript) {
        window.document.head.appendChild(script);
    } else if (callback) {
        callback();
    }
}

export default registerTealiumTracker;